export const me = state => state.user;

export const sendOrderProcessed = state => state.sendOrderProcessed;
export const sendOrderProcessedSuccess = state => state.sendOrderProcessedSuccess;
export const sendOrderProcessedError = state => state.sendOrderProcessedError;
